export const defaultPanelFeatureTranslationJP = {
  DefaultPanel: {
    title: 'デフォルトパネル設定',
    save_button: '保存',
    warn_field_required: '画像が設定されていません。',
    image_validation_error: '画像が未設定のデフォルトパネルがあるため保存できません。',
    success_save: '保存しました。',
  },
};
